var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"customButtonWrapper",class:[
    _vm.isSingle ? '' : 'multiple',
    _vm.isDisabled ? 'disabled' : '',
    _vm.buttonType,
    _vm.isLoading ? 'loading' : '',
  ],on:{"click":_vm.submit}},[_c('p',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isLoading),expression:"!isLoading"}],domProps:{"innerHTML":_vm._s(_vm.customButtonTxt)}}),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isLoading),expression:"isLoading"}]},[_c('img',{directives:[{name:"svg-inline",rawName:"v-svg-inline"}],staticClass:"loadingIcon",attrs:{"src":require("../assets/imgs/loadingColor.svg"),"alt":"loading"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }